import React from 'react';
import PropTypes from 'prop-types';
import s from './EmptyGradebook.module.css';
const emptyImgUrl = new URL(
  '../../../../assets/empty_view.png',
  import.meta.url,
).href;

const EmptyGradebook = ({ type, onTabChange }) => {
  let headerText = 'Your course is ready for enrollments!';
  let subheaderText = 'To add your first enrollment, go to the';
  let tabName = 'people';
  let pageName = 'People';

  if (type === 'assignments') {
    headerText = 'Your course is ready for assignments!';
    subheaderText = 'To add your first assignment, go to the';
    tabName = 'assignments';
    pageName = 'Course Home';
  }

  return (
    <div className={s.emptyView}>
      <p className={s.emptyViewTitle}>{headerText}</p>
      <p className={s.emptyViewText}>
        {subheaderText}
        <button
          className={s.emptyViewLink}
          onClick={() => {
            onTabChange(tabName);
          }}
        >
          {pageName}
        </button>
        page.
      </p>
      <img
        src={emptyImgUrl}
        alt="empty view"
        className={s.emptyViewImg}
        data-test-id="empty-view-image"
      />
    </div>
  );
};

EmptyGradebook.propTypes = {
  type: PropTypes.string,
};

export default EmptyGradebook;
